import { useEffect, useRef, useCallback } from "react";

const EVENTS = ["mousemove", "mousedown", "keydown", "touchstart", "scroll", "click"];

const useIdleTimer = ({ idleTimeout, warningTimeout, onWarning, onLogout, onActivity }) => {
  const idleRef = useRef(null);
  const warningRef = useRef(null);
  const onActivityRef = useRef(onActivity);
  const onWarningRef = useRef(onWarning);
  const onLogoutRef = useRef(onLogout);

  useEffect(() => { onActivityRef.current = onActivity; }, [onActivity]);
  useEffect(() => { onWarningRef.current = onWarning; }, [onWarning]);
  useEffect(() => { onLogoutRef.current = onLogout; }, [onLogout]);

  const clearTimers = useCallback(() => {
    clearTimeout(idleRef.current);
    clearTimeout(warningRef.current);
  }, []);

  const startTimers = useCallback(() => {
    clearTimers();

    idleRef.current = setTimeout(() => {
      onWarningRef.current?.();

      warningRef.current = setTimeout(() => {
        onLogoutRef.current?.();
      }, warningTimeout);
    }, idleTimeout);
  }, [clearTimers, idleTimeout, warningTimeout]); // onWarning & onLogout keluar dari deps

  const resetTimer = useCallback(() => {
    onActivityRef.current?.();
    startTimers();
  }, [startTimers]);

  useEffect(() => {
    startTimers();
    EVENTS.forEach((e) => window.addEventListener(e, resetTimer));

    return () => {
      clearTimers();
      EVENTS.forEach((e) => window.removeEventListener(e, resetTimer));
    };
  }, [startTimers, resetTimer, clearTimers]);

  return { resetTimer };
};

export default useIdleTimer;